import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { AuthActions } from '../state/auth/auth.action-types';
import { SocketMainService } from '../../socket/socket-main.service';

/**
 * Connect socket when required data is loaded (after successful login/app init)
 */
export const connectSocketOnRequiredDataLoaded = createEffect(
  (actions$ = inject(Actions), socketMainService = inject(SocketMainService)) => {
    return actions$.pipe(
      ofType(AuthActions.requiredDataLoadedSuccess),
      tap(() => {
        if (!socketMainService.isValid()) {
          socketMainService.connect().catch((error: Error) => {
            console.error('Failed to connect to socket:', error);
          });
        }
      }),
    );
  },
  { functional: true, dispatch: false },
);

/**
 * Disconnect socket on logout
 */
export const disconnectSocketOnLogout = createEffect(
  (actions$ = inject(Actions), socketMainService = inject(SocketMainService)) => {
    return actions$.pipe(
      ofType(AuthActions.logout),
      tap(() => {
        socketMainService.disconnect();
      }),
    );
  },
  { functional: true, dispatch: false },
);
